<template>
  <div>
    <hint-widget hintName="statisticsGone" type="text" btnMore></hint-widget>

    <statistics-filter
      v-if="filterParams.hotspotName"
      @filter="filterItems"
      :filters="['hotspot', 'cntDaysGone']"
      :default-params="filterParams"
      :loading="loading"
    ></statistics-filter>

    <v-alert type="error" :value="error">{{ error }}</v-alert>
    <div class="layout">
      <div class="flex md8 xl9">
        <v-data-table
          @update:pagination="updatePagination"
          v-model="selected"
          item-key="username"
          :headers="headers"
          :items="items"
          :total-items="pagination.totalItems"
          :pagination.sync="pagination"
          :rows-per-page-items="rowsPerPageItems"
          :loading="loading"
          sort-icon="icon icon-arrow-top ml-2"
          next-icon="icon icon-angle-right d-flex align-center"
          prev-icon="icon icon-angle-left d-flex align-center"
          :select-all="true"
          must-sort
        >
          <template v-slot:items="props">
            <tr
              :active="props.selected"
              @click="props.selected = !props.selected"
            >
              <td>
                <v-checkbox
                  :input-value="props.selected"
                  onIcon=""
                  offIcon=""
                  primary
                  hide-details
                ></v-checkbox>
              </td>
              <td>{{ props.item.username }}</td>
              <td>{{ props.item.callingstationid }}</td>
              <td>{{ props.item.cntAll }}</td>
              <td>{{ props.item.maxDate }}</td>
            </tr>
          </template>
        </v-data-table>
      </div>
      <div class="flex md4 xl3 pt-5 mt-2 pl-3 ml-2">
        <sms-mailing
          :download="filterParams"
          :phoneSelected="phoneSelected"
          :countAllPhones="countAllPhones"
          type="statisticsGeneral"
          @editSmsDialog="editSmsDialog"
        ></sms-mailing>
      </div>
    </div>
  </div>
</template>

<script>
import RequestApi from "../../modules/requestApi";
import Common from "../../modules/common";
import StatisticsFilter from "./StatisticsFilter.vue";
import SmsMailing from "../sms/SmsMailing.vue";
import HintWidget from "../common/HintWidget.vue";
import moment from "moment";
moment.locale("ru");

export default {
  name: "StatisticsGone",

  components: {
    StatisticsFilter,
    SmsMailing,
    HintWidget
  },
  props: {
    // id хотспота
    hotspot_id: Number,
    // указывается для выбора по умолчанию
    hotspotName: String,
    // параметры для фильтра данных
    filterParams: {
      type: Object,
      // значения по умолчанию
      default: function() {
        return {
          hotspotName: "",
          range: {
            start: moment().subtract(1, "quarter"),
            end: new Date()
          },
          cntDaysGone: 30
        };
      }
    }
  },
  data: () => ({
    error: "",
    loading: false,
    // список выбранных строк checkbox-ми
    selected: [],
    // заголовки столбцов таблицы
    headers: [
      {
        text: "Телефон",
        sortable: false,
        value: "username"
      },
      {
        text: "MAC адрес",
        sortable: false,
        value: "callingstationid"
      },
      {
        text: "Всего авторизаций",
        sortable: false,
        value: "cntAll"
      },
      {
        text: "Последний визит",
        sortable: true,
        value: "maxDate"
      }
    ],
    // данные таблицы
    items: [],
    // выбор к-ва строк на странице
    rowsPerPageItems: [10, 25, 50],

    pagination: {
      descending: true,
      page: 1,
      rowsPerPage: 25,
      sortBy: "maxDate"
    },
    countAllPhones: 0
  }),

  computed: {
    //выбранные номера
    phoneSelected() {
      return new Set(this.selected.map(item => item.username));
    }
  },

  mounted() {
    this.loading = true;
    // загружаем список хотспотов
    this.$store.dispatch("hotspotListLoad").then(() => {
      this.init();
    });
  },

  methods: {
    init() {
      if (this.hotspotName) {
        this.filterParams.hotspotName = this.hotspotName;
        this.filterParams.hotspot_id = this.hotspot_id;
      } else {
        this.filterParams.hotspotName = this.$store.getters.hotspotList[0].hotspot_name;
        this.filterParams.hotspot_id = this.$store.getters.hotspotList[0].id;
      }
      // передаем в StatisticsView текущие параметры фильтра для сохранения в шаблоны
      this.$emit("setFilter", this.filterParams);
      this.getListCnt(this.filterParams).then(() => {
        this.getList(this.pagination, this.filterParams);
      });
    },

    /**
     * Получение строк из базы
     */
    getList(pagination, filterParams) {
      this.error = "";
      this.loading = true;
      return new Promise((resolve, reject) => {
        RequestApi.statGoneList({
          ...filterParams,
          limit: pagination.rowsPerPage,
          offset:
            pagination.rowsPerPage * pagination.page - pagination.rowsPerPage,
          orderBy: {
            sortBy: pagination.sortBy,
            descending: pagination.descending ? "DESC" : "ASC"
          }
        })
          .then(data => {
            this.items = data;
            this.loading = false;
            resolve();
          })
          .catch(error => {
            this.items = [];
            this.loading = false;
            this.error = error;
            reject();
          });
      });
    },

    /**
     * Получение общего к-во строк из базы
     */
    getListCnt(filterParams) {
      return new Promise((resolve, reject) => {
        RequestApi.statGoneListCnt(filterParams)
          .then(data => {
            this.pagination.totalItems = data.total;
            this.countAllPhones = data.countPhones;
            resolve();
          })
          .catch(error => {
            this.error = error;
            reject();
          });
      });
    },

    /**
     * Срабатывает каждый раз по событиям pagination и sort данных
     * @param pagination
     */
    updatePagination(pagination) {
      // делаем запрос, когда подгрузилось к-во всех строк,
      // не была изменена сортировка либо при смене сортировки ждем когда переключится на 1 страницу
      if (
        this.pagination.totalItems &&
        (this.pagination.sortBy === pagination.sortBy ||
          (this.pagination.sortBy !== pagination.sortBy &&
            pagination.page === 1))
      ) {
        this.loading = true;
        Common.callLastInTime(() => {
          this.getList(pagination, this.filterParams);
        }, 500);
      }
    },

    /**
     * Фильтрация данных
     */
    filterItems(params) {
      // передаем в StatisticsView текущие параметры фильтра для сохранения в шаблоны
      this.$emit("setFilter", params);
      this.pagination.page = 1;
      this.getListCnt(params).then(() => {
        this.getList(this.pagination, params);
      });
    },
    // отправка смс
    editSmsDialog(params) {
      this.$emit("editSmsDialog", params);
    }
  }
};
</script>
